const showErrorProductPage = (message) => {
  console.error(`Product verification error: ${message}`)

  const errorComponent = document.querySelector('.alert-danger')

  if (errorComponent) {
    errorComponent.textContent = message
  } else {
    const errorBlock = document.createElement('div')

    errorBlock.classList.add('flash-warning', 'alert', 'alert-danger')
    errorBlock.textContent = message

    const previewsSiblingEl = document.querySelector('.fav-wrapper')

    if (previewsSiblingEl) {
      previewsSiblingEl.after(errorBlock)
    }
  }
}

export { showErrorProductPage }
